// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__2Nxam","formControl":"addForm_formControl__Mi+IS","list":"addForm_list__qObYY","btnWrpper":"addForm_btnWrpper__9CWjY"};